export function buildMainClientUrl(paths: string[], baseUrl: string): string {
	const url = new URL(baseUrl);
	url.pathname = paths
		.filter((path) => {
			const cleanPath = (path || '').trim();
			return cleanPath !== '' && cleanPath !== '/';
		})
		.join('/');
	return url.href;
}

export function buildMainClientNodeUrl(baseUrl: string, nodeId: string): string {
	return buildMainClientUrl(['home', 'node', nodeId], baseUrl);
}
